import { Route, Routes } from 'react-router-dom'
import HomePage from '../page/home'
import { CallbackPage } from '../page/callback'

const authRoutes = [
    {
        path: '/',
        element: <HomePage />,
    },
    {
        path: '/callback',
        element: <CallbackPage />,
        noAuth: true,
    },
]

export default function Router() {
    return (
        <Routes>
            {authRoutes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                />
            ))}
        </Routes>
    )
}
